// extracted by extract-css-chunks-webpack-plugin
module.exports = {"floating-filter-button":"V6BEy","slide-in":"pUXG9"};